<div class="w-full">
  <router-outlet />
</div>